module.exports = __webpack_public_path__ + "img/6.44d8f32b.jpg";